// Canonical AI use-case labels — the product feature a usage row is attributed to.
// Recorded on each ai-usage row (the `useCase` field) so org owners can see HOW their
// team uses the product (the "By feature" usage chart). Keep these stable: they are
// persisted on usage rows and grouped in the dashboards. Add a new label here when a
// new AI feature is introduced rather than inventing an ad-hoc string at the call site.
export const USE_CASES = {
  WORKFLOW_DIAGRAM: 'workflow-diagram',
  WORKFLOW_FROM_CODE: 'workflow-from-code',
  ENTITIES: 'entities',
  READ_MODELS: 'read-models',
  COMMANDS: 'commands',
  DOMAIN_EVENTS: 'domain-events',
  CARDS: 'cards',
  CODE_GENERATION: 'code-generation',
  ASSISTANT: 'assistant'
}

// Human-readable label for a useCase slug (for the dashboards). Falls back to a
// title-cased version of the slug, so an unmapped/legacy value still renders sensibly.
export const useCaseLabel = (slug) => {
  const labels = {
    'workflow-diagram': 'Workflow diagram',
    'workflow-from-code': 'Workflow from code',
    entities: 'Entities',
    'read-models': 'Read models',
    commands: 'Commands',
    'domain-events': 'Domain events',
    cards: 'Cards',
    'code-generation': 'Code generation',
    assistant: 'Assistant'
  }
  if (labels[slug]) {
    return labels[slug]
  }
  if (!slug || slug === 'unknown') {
    return 'Unknown'
  }

  return slug.charAt(0).toUpperCase() + slug.slice(1).replace(/-/g, ' ')
}
